module.exports = __webpack_public_path__ + "static/img/4.00f8b15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shenfree/4.png
// module id = yW/W
// module chunks = 0